import React from 'react';
import { Box, SvgIcon } from '@mui/material';
import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';
import Header from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Header';
import { ReactComponent as icon } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/icon/BorrowersIcon1.svg';
import { useTranslation } from 'react-i18next';

const HeaderSection = ({ arrears }: { arrears: Arrears }) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');
  return (
    <Box display="flex" flexDirection="row" gap="8px">
      <Box display="flex" flexDirection="row" gap="12px" maxWidth="821px" flexGrow={1}>
        <>
          <SvgIcon
            component={icon}
            inheritViewBox
            aria-label="borrower icon"
            sx={{ fontSize: 60, color: 'white' }}
          />
          <Box>
            <Header size="medium">{arrears.lenderName}</Header>
            <Header size="xsmall">
              {t('commonInformationSection.cmhcLoanNumber', {
                loanNumber: arrears.loanNumber
              })}
            </Header>
          </Box>
        </>
      </Box>
    </Box>
  );
};

export default HeaderSection;
